import React from 'react'

function Space({space}) {
    return (<div style={{height: space, width: space}}/>)
}

export default Space;
